const isProdFlex =
  (typeof import.meta !== 'undefined' && import.meta.env?.MODE === 'production') ||
  process.env.NODE_ENV === 'production' ||
  process.env.REACT_APP_SHARETRIBE_ENV === 'production';

export const SHARETRIBE_PUBLIC_CLIENT_ID = isProdFlex
  ? process.env.REACT_APP_SHARETRIBE_CLIENT_ID
  : process.env.REACT_APP_SHARETRIBE_CLIENT_ID_TEST;

export const SHARETRIBE_ENV = isProdFlex ? 'production' : 'test';
